export default "__VITE_ASSET__CNF5JrdC__"